export default __webpack_public_path__ + "static/media/shakinghands3.85239f7e.jpg";